









import { Component, Vue } from 'vue-property-decorator';
import { SidebarModuleMapper } from '@/store/modules/sidebar';

const Mappers = Vue.extend({
  computed: SidebarModuleMapper.mapGetters(['sidebarState']),
  methods: {
    ...SidebarModuleMapper.mapMutations({
      toggle: 'toggle',
    }),
  },
});

@Component
export default class NavbarToggle extends Mappers {
  openSidebar() {
    this.toggle(!this.sidebarState);
  }
}
